import { Pipe, PipeTransform } from '@angular/core';
import { SearchEngineFieldAddress } from '@domains/search-engine/entities/address-search-field';
import { SearchEngineFieldLocation } from '@domains/search-engine/entities/location-search-field';
import { SearchEngineFieldLocationPoleEmploi } from '@domains/search-engine/entities/location-search-pole-emploi-field';
import { SearchEngineFieldRomesInput } from '@domains/search-engine/entities/romes-input-search-field';
import { SearchEngineFieldSelectDuration } from '@domains/search-engine/entities/select-duration-field';
import { SearchEngineFieldSelect } from '@domains/search-engine/entities/select-search-field';
import { SearchEngineFieldSelectWeeklyDuration } from '@domains/search-engine/entities/select-weekly-duration-field';
import { SearchEngineFieldTextInput } from '@domains/search-engine/entities/text-input-search-field';
import { SearchEngineFieldTextRomesInput } from '@domains/search-engine/entities/text-romes-input-search-field';
import { SearchEngineField, SearchEngineFieldType } from '@domains/search-engine/search-engine-field';

@Pipe({
  name: 'castToSpecificFieldType',
})
export class CastToSpecificFieldTypePipe implements PipeTransform {
  transform(value: SearchEngineField): SearchEngineField | any {
    switch (value.type) {
      case SearchEngineFieldType.Location:
      case SearchEngineFieldType.LocationEures:
        return value as SearchEngineFieldLocation;
      case SearchEngineFieldType.Address:
        return value as SearchEngineFieldAddress;
      case SearchEngineFieldType.LocationPoleEmploi:
        return value as SearchEngineFieldLocationPoleEmploi;
      case SearchEngineFieldType.Select:
        return value as SearchEngineFieldSelect;
      case SearchEngineFieldType.TextInput:
        return value as SearchEngineFieldTextInput;
      case SearchEngineFieldType.DurationSelect:
        return value as SearchEngineFieldSelectDuration;
      case SearchEngineFieldType.RomesInput:
        return value as SearchEngineFieldRomesInput;
      case SearchEngineFieldType.TextRomesInput:
        return value as SearchEngineFieldTextRomesInput;
      case SearchEngineFieldType.WeeklyDurationSelect:
        return value as SearchEngineFieldSelectWeeklyDuration;
      default:
        return value as any;
    }
  }
}
